<template>
  <w-icon-wrapper
    :width='21.6'
    :height='24'
    icon-name='work-nav-official-holidays-icon'
    view-box='0 0 21.6 24'
  >
    <path
      id="_10_Feiertage_Icon"
      data-name="10_Feiertage_Icon"
      d="M133.8-860.8a2.9,2.9,0,0,1-2.13-.87,2.9,2.9,0,0,1-.87-2.13,2.9,2.9,0,0,1,.87-2.13,2.9,2.9,0,0,1,2.13-.87,2.9,2.9,0,0,1,2.13.87,2.9,2.9,0,0,1,.87,2.13,2.9,2.9,0,0,1-.87,2.13A2.9,2.9,0,0,1,133.8-860.8ZM122.4-856a2.311,2.311,0,0,1-1.695-.7,2.311,2.311,0,0,1-.705-1.7v-16.8a2.311,2.311,0,0,1,.705-1.7,2.311,2.311,0,0,1,1.695-.705h1.2V-880H126v2.4h9.6V-880H138v2.4h1.2a2.311,2.311,0,0,1,1.7.705,2.311,2.311,0,0,1,.705,1.7v16.8a2.311,2.311,0,0,1-.705,1.7,2.311,2.311,0,0,1-1.7.7Zm0-2.4h16.8v-12H122.4Zm0-14.4h16.8v-2.4H122.4Zm0,0v0Z"
      transform="translate(-120 880)"
      fill="currentColor"
    />
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconNavOfficialHolidays' };
</script>

